export default __webpack_public_path__ + "static/media/message.3fd9c200.png";